import React from 'react';
import { Icon } from '@iconify/react';
import { Button } from '@mui/material';
import { InfoCard } from '../../../../components';
import { infoCardListStyles } from '../../../../components/info-card-list/info-card-list-helper';
import { DOCUMENTATION_CARD } from './documentation-helper';

export const DocumentationCard = (): React.JSX.Element => {
    const handleButtonClick = (): void => {
        window.open(process.env.REACT_APP_DEV_DOCS_URL, '_blank');
    };

    return (
        <InfoCard
            title={DOCUMENTATION_CARD.TITLE}
            description={DOCUMENTATION_CARD.DESCRIPTION}
            action={
                <Button
                    color='inherit'
                    size='medium'
                    style={infoCardListStyles.infoCardButton}
                    onClick={handleButtonClick}
                    startIcon={
                        <Icon
                            icon={'mdi:console'}
                            style={infoCardListStyles.infoCardIcon}
                        />
                    }
                >
                    {DOCUMENTATION_CARD.ACTION}
                </Button>
            }
        />
    );
};
